import React from 'react';
/**
 * place children in corner of parent
 * options: top left, top right, bottom left, bottom right
 */
const SimplePosition = ({
  children,
  position = 'top right',
  padding = 0,
  paddingY = 0,
  paddingX = 0,
}: {
  children: any;
  position?: string;
  padding?: number;
  paddingY?: number;
  paddingX?: number;
}) => {
  const sizingRef = React.useRef<any>(null);
  const [left, setLeft] = React.useState(0);
  const [top, setTop] = React.useState(0);

  const handleChangePosition = () => {
    if (sizingRef && sizingRef.current) {
      const doc = sizingRef.current.ownerDocument;
      const win = doc.defaultView || doc.parentWindow;
      const winY =
        win.pageYOffset !== undefined
          ? win.pageYOffset
          : (doc.documentElement || doc.body.parentNode || doc.body).scrollTop;
      const width = sizingRef.current.offsetWidth;
      const height = sizingRef.current.offsetHeight;
      const parentWidth = sizingRef.current.parentElement.offsetWidth;
      const parentHeight = sizingRef.current.parentElement.offsetHeight;
      const pBounds = sizingRef.current.parentElement.getBoundingClientRect();
      const parentX = pBounds.x;
      const parentY = pBounds.y + winY;
      const pos = position.split(' ');
      const yPos = pos[0];
      const xPos = pos[1];

      if (yPos === 'top') {
        setTop(parentY + paddingY + padding);
      } else {
        setTop(parentY + parentHeight - height + paddingY + padding);
      }
      if (xPos === 'left') {
        setLeft(parentX + paddingX + padding);
      } else if (xPos === 'center') {
        setLeft(parentX + parentWidth / 2 - width / 2);
      } else {
        // right
        setLeft(parentX + parentWidth - width - paddingX - padding);
      }
    }
  };

  React.useLayoutEffect(() => {
    handleChangePosition();
    window.addEventListener('resize', handleChangePosition);

    return () => {
      window.removeEventListener('resize', handleChangePosition);
    };
  }, [sizingRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div ref={sizingRef} style={{ position: 'absolute', top, left }}>
      {children}
    </div>
  );
};

export default SimplePosition;
